import { PropsWithChildren, useEffect } from 'react'
import { AuthProvider as OIDCAuthProvider, useAuth } from 'react-oidc-context'
import { sentinelConfig } from '../../../../util/sentinalConfig'
import useAdminIdle from '../../hooks/useAdminIdle'

const AdminIdleWrapper = ({ children }: PropsWithChildren) => {
  const auth = useAuth()
  const { start, pause } = useAdminIdle()

  useEffect(() => {
    if (auth?.isAuthenticated) {
      start()
    }
    return () => {
      pause()
    }
  }, [auth?.isAuthenticated, start, pause])

  return <>{children}</>
}

export const AdminAuthProvider = ({ children }: PropsWithChildren) => {
  return (
    <OIDCAuthProvider
      {...sentinelConfig}
      onSigninCallback={() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        )
        window.location.reload()
      }}
    >
      <AdminIdleWrapper>{children}</AdminIdleWrapper>
    </OIDCAuthProvider>
  )
}
